module.exports = __webpack_public_path__ + "img/img21.9d13675b.svg";